<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div v-for="(value, i) in fieldValue" :key="i" class="input-group mb-3">
        <input
          v-model="fieldValue[i]"
          :placeholder="field.placeholder"
          class="form-control"
          type="text"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click.prevent="append(i)"
          >
            +
          </button>
        </div>
        <div class="input-group-append">
          <button
            class="btn btn-outline-warning"
            type="button"
            @click.prevent="remove(i)"
          >
            -
          </button>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import isArray from "lodash-es/isArray";

export default {
  name: "FormPhonesField",

  mixins: [FieldMixin],

  created() {
    if (!isArray(this.fieldValue)) {
      this.fieldValue = [];
    }
    if (!this.fieldValue.length) {
      this.fieldValue.push("");
    }
  },

  methods: {
    remove(i) {
      this.fieldValue.splice(i, 1);
      if (this.fieldValue.length === 0) {
        this.fieldValue.push("");
      }
    },

    append(i) {
      this.fieldValue.splice(i + 1, 0, "");
    },
  },
};
</script>
